import React from 'react';
import ReactDOM from 'react-dom';
export default {
	twitter: function(){
		return (
			<svg className="twitter-icon">
			    <g fillRule="evenodd">
			        <g transform="translate(-46.000000, 0.000000)">
			            <g>
			                <g transform="translate(46.000000, 0.000000)">
			                    <rect className="icon-background" x="0" y="0" rx="3" width="30" height="30"></rect>
			                    <g className="icon-symbol" transform="translate(6.486486, 7.500000)">
			                        <path d="M16.526779,1.76050427 C15.9319971,2.01940787 15.2601672,2.20042404 14.5876173,2.27831148 C15.2860899,1.86435418 15.8290264,1.21673458 16.0616106,0.440023764 C15.4149833,0.828018582 14.6913081,1.08764337 13.9157874,1.24269706 C13.3210055,0.595077455 12.441794,0.207082638 11.4596118,0.207082638 C9.59821818,0.207082638 8.09830213,1.68261683 8.09830213,3.52162573 C8.09830213,3.78052933 8.12422483,4.01347046 8.17607022,4.27237407 C5.3836197,4.1165992 2.87559877,2.82208117 1.22086661,0.802777284 C0.936437021,1.29462202 0.755698217,1.86435418 0.755698217,2.45932765 C0.755698217,3.62475446 1.3504801,4.63512759 2.25489419,5.23010105 C1.7119577,5.20413857 1.19494392,5.04908488 0.72977552,4.81614376 L0.72977552,4.84210623 C0.72977552,6.44745282 1.89341658,7.79389581 3.44445795,8.10472437 C3.16002836,8.1826118 2.84967607,8.2078531 2.53932378,8.2078531 C2.33266228,8.2078531 2.12600078,8.1826118 1.91933928,8.15664933 C2.35858498,9.47712983 3.59999413,10.4348568 5.07326741,10.4608193 C3.90962635,11.34138 2.46227577,11.8591872 0.884591627,11.8591872 C0.600162035,11.8591872 0.341655141,11.8591872 0.0831482461,11.8332248 C1.5571416,12.7657104 3.34076716,13.3094801 5.25400621,13.3094801 C11.4596118,13.3094801 14.8461242,8.25977806 14.8461242,3.88365807 L14.8461242,3.46970077 C15.4927514,3.00309734 16.0875333,2.40812387 16.526779,1.76050427"></path>
			                    </g>
			                </g>
			            </g>
			        </g>
			    </g>
			</svg>
		);
	}
}


// WEBPACK FOOTER //
// ./medscape_modules/twitter-widget/icons.jsx